// eslint-disable-next-line no-extend-native,func-names
Array.prototype.at = Array.prototype.at || function (index) {
  return index >= 0 ? this[index] : this[this.length + index];
};
// eslint-disable-next-line no-extend-native,func-names
String.prototype.replaceAll = String.prototype.replaceAll || function replaceAll(search, replace) {
  return this.replace(new RegExp(search, 'g'), replace);
};
